var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('customer-address-inputs',{attrs:{"is-guest":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})}
var staticRenderFns = []

export { render, staticRenderFns }